import { useRouter } from "next/router";

import { FC, useCallback, useEffect, useState } from "react";

import SuccessModal from "modules/Payment/SuccessModal";

const SectionSuccessModal: FC = () => {
  const { query } = useRouter();
  const [isSuccessModalOpen, setSuccessModalOpen] = useState(false);
  const toggleSuccessModal = useCallback(() => {
    setSuccessModalOpen((prevState) => !prevState);
  }, []);
  const payment = {
    cryptoTransactionStatus: query.cryptoStatus,
    fiatTransactionStatus: query.status,
    fiatTransactionId: query.btid,
  };

  useEffect(() => {
    if (
      (payment.fiatTransactionStatus === "success" ||
        payment.cryptoTransactionStatus === "success") &&
      !payment.fiatTransactionId
    ) {
      toggleSuccessModal();
    }
  }, [
    payment.fiatTransactionStatus,
    payment.cryptoTransactionStatus,
    payment.fiatTransactionId,
    toggleSuccessModal,
  ]);

  if (!isSuccessModalOpen) {
    return null;
  }

  return (
    <SuccessModal isOpen={isSuccessModalOpen} onClose={toggleSuccessModal} />
  );
};

export default SectionSuccessModal;
